import React from 'react'
import { getUrl, getDescText, getPublishDate, getPageDateShort } from '../../common/services/builders'

function PublishedPapersSearchItem({ entry, settings }) {



    return (
        <div className="search-result">
            <div className="row">
                <div className="small-6 column">
                    
                    {renderTypeTag(entry)}
                </div>
                <div className="small-6 column text-right">
                    {renderMemberTag(entry)}
                </div>
            </div>
            <div className="row column">
                <h4><a href={getUrl(entry)}>{entry.title}</a></h4>
                <span dangerouslySetInnerHTML={{__html: getDescText(entry)}}></span>
                <span className="date">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-clock"></use>
                    </svg>
                    {getPageDateShort(entry)}
                </span>
            </div>
        </div>
    )
    
}

function renderMemberTag(entry) {
    if (entry.sys.contentTypeId == 'weldasearch'){
        return <span className="category--tag">All members</span>
    }

    if (entry.sys.contentTypeId == 'publishedPapers' || entry.sys.uri.startsWith("/technical-knowledge/published-papers/") ){
        return <span className="category--tag">Public</span>
    }
    if(entry.sys.metadata.permission){
        switch (entry.sys.metadata.permission) {
            case 'OPEN':
                return <span className="category--tag">All members</span>
            case 'IM':
                return <span className="category--tag">Industrial members</span>
            case 'PRO':
                return <span className="category--tag">Professional members</span>	
            default:
                return <span className="category--tag">Public</span>
        }
    }
    else{
        return <span className="category--tag">Public</span>
    }
}

function renderTypeTag(entry){
    if (entry.sys.contentTypeId == 'publishedPapers' || entry.sys.uri.startsWith("/technical-knowledge/published-papers/") ){
        return <span className="category--tag">Published Paper</span>
    }

    if(entry.sys.dataFormat == 'webpage'){
        return <span className="category--tag">Webpage</span>
    }
    else{
        return <span className="category--tag">{entry.sys.contentTypeId.split(/(?=[A-Z])/).join(" ")}</span>
    }
}

export default PublishedPapersSearchItem;